/**
 * Platform detection for Capacitor mobile app vs web browser.
 */

export function isNative() {
  return typeof window !== 'undefined' &&
    window.Capacitor?.isNativePlatform?.() === true;
}

export function getClientPlatform() {
  if (typeof window === 'undefined') {
    return 'web';
  }
  if (isNative()) {
    return 'mobile';
  }
  return window.innerWidth <= 768 ? 'mobile' : 'web';
}

export function getApiBaseUrl() {
  if (isNative()) {
    return import.meta.env.VITE_BACKEND_URL || '';
  }
  return '';
}

export function isTavernApp() {
  return window.location?.pathname?.startsWith('/tavern-app');
}
